import React, { useEffect, useState } from 'react';

/**
 * FadingPhotoGallery
 * - Displays one image at a time
 * - Each image visible for `displayMs` ms, then cross-fades to the next over `fadeMs` ms
 * - Auto loops indefinitely
 * - No user controls
 * - Fixed aspect-ratio container prevents layout shift
 */
const FadingPhotoGallery = ({
  images = [],
  displayMs = 3000,
  fadeMs = 800,
  alt = 'Bhartiya MRO workshop photo',
  aspectRatio = '16 / 10',
  className = '',
}) => {
  const [active, setActive] = useState(0);

  useEffect(() => {
    if (!images.length) return;
    const id = setInterval(() => {
      setActive((prev) => (prev + 1) % images.length);
    }, displayMs);
    return () => clearInterval(id);
  }, [images.length, displayMs]);

  if (!images.length) return null;

  return (
    <div
      className={`relative w-full overflow-hidden rounded-md bg-slate-100 ${className}`}
      style={{ aspectRatio }}
      data-testid="fading-photo-gallery"
    >
      {images.map((src, i) => (
        <img
          key={src}
          src={src}
          alt={`${alt} ${i + 1}`}
          loading={i === 0 ? 'eager' : 'lazy'}
          className="absolute inset-0 w-full h-full object-cover"
          style={{
            opacity: active === i ? 1 : 0,
            transition: `opacity ${fadeMs}ms ease-in-out`,
          }}
        />
      ))}
    </div>
  );
};

export default FadingPhotoGallery;
